import { buildPrompt } from '@/ai/utils/promptBuilder'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import { createSystemMessage, createUserMessage } from '@/ai/utils/promptUtils'

export const buildDataFieldExampleDataPrompt = ({ entity, dataField }) => {
  const messages = []

  messages.push(createSystemMessage(systemMessages.EVENT_MODELING_DDD_EXPERT))

  const promptSections = []

  promptSections.push({
    title: 'Background entity (JSON format)',
    contentType: 'codeblock',
    language: 'json',
    content: JSON.stringify(entity)
  })

  promptSections.push({
    title: 'Request',
    content: `
      Review the information provided above, then generate example data for the data field
      labeled - "${dataField.name}". Generate three rows of example data for this field.
      If example data already exists, try to provide different values in your response.
      Each example data value must be at most 30 characters long.
    `
  })

  const example = {
    exampleData: ['Example 1', 'Example 2', 'Example 3']
  }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('exampleData', JSON.stringify(example))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
